<template>
  <div class="home-container">
    <div class="home-content">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="name" label="分类名称" align="center">
        </el-table-column>
        <el-table-column prop="updateTime" label="创建时间" align="center">
        </el-table-column>                             
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :name="modalTitle" :visible.sync="isAddModal" width="40%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >  
           <el-row>
            <el-col :span="12">
              <el-form-item label="分类名称" prop="name">
                <el-input
                placeholder="请输入分类名称"
                v-model="addData.name"
                clearable
                ></el-input>
              </el-form-item>
            </el-col>          
          </el-row>         
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalTitle: "新增",
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        name:''
      },
      addDataRules: {
        name: [{ required: true, message: "请上传标题", trigger: "blur" }]
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },
    // 修改
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.dispatchOrderClassDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            name: this.addData.name
          };
          this.$Apis.dispatchOrderClassAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad()
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage
      };
      this.$Apis.dispatchOrderClassList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item,ind) => {
            item.status = item.status == 1 ? true : false;
            item.ind = ind + 1
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
.actice .el-upload--picture-card {
  display: none !important;
}
</style>